<template>
  <div class="p-4">
    <h1 class="text-2xl font-bold mb-4">Sign Terms & Conditions</h1>
    
    <div v-if="loading" class="flex justify-center items-center h-64">
      <ProgressSpinner />
    </div>
    
    <!-- Terms Dialog Component -->
    <TermsDialog 
      v-if="!loading"
      v-model:visible="termsDialogVisible" 
      v-model:acceptedTerms="acceptedTerms"
      :type="isCompany ? 'Company' : 'Individual'"
      :companyName="companyName"
      :closable="false"
      @signature="handleSignature"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import TermsDialog from '../Register/TermsDialog.vue';
import { useToast } from 'primevue/usetoast';
import ProgressSpinner from 'primevue/progressspinner';
import AuthService from '../../services/AuthService';
const toast = useToast();
const store = useStore();
const router = useRouter();

const loading = ref(true);
const termsDialogVisible = ref(false);
const acceptedTerms = ref(false);

// Get user information from Vuex store
const isCompany = computed(() => store.getters.isCompany);
const companyName = computed(() => isCompany.value ? store.state.user.companyName : '');
const userId = computed(() => store.getters.userId);

// Open the terms dialog
const openTermsDialog = () => {
  termsDialogVisible.value = true;
};

// Handle signature event from the dialog
const handleSignature = async (signatureData) => {
  try {

    console.log(signatureData);
    console.log(userId.value);
    await AuthService.signTcs(userId.value, signatureData.representativeName, companyName.value, signatureData.signatureImage);
    toast.add({
      severity: 'success',
      summary: 'Terms Accepted',
      detail: `Terms accepted by ${signatureData.representativeName}`,
      life: 3000
    });
    
    // Redirect or show confirmation
    setTimeout(() => {
      router.push('/');
    }, 2000);
    
  } catch (err) {
    console.error('Error saving signature:', err);
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Failed to save signature. Please try again.',
      life: 3000
    });
  }
};

// Initialize component
onMounted(async () => {
  // If we need to refresh user data, we can do it here
  if (!store.state.user) {
    try {
      await store.dispatch('getUser');
    } catch (err) {
      console.error('Error loading user data:', err);
    }
  }
  
  loading.value = false;
  openTermsDialog();
});
</script>

<style scoped>
/* Add any component-specific styles here */
</style>